import React, { useState } from 'react';
import _head from 'lodash/head';
import _split from 'lodash/split';
import { PainEmoji1to2, PainEmoji3to4, PainEmoji5to6, PainEmoji7to8, PainEmoji9to10 } from 'assets/eTriage';
import { PainCard } from 'styles/blocks/painScale';

export function PainScale({ onSelectOption, isClinicalReviewMode, selected, answer }) {
  const [emoji] = useState(() => {
    const leadNum = _head(answer.text);
    switch (leadNum) {
      case '1':
        return <PainEmoji1to2 />;
      case '3':
        return <PainEmoji3to4 />;
      case '5':
        return <PainEmoji5to6 />;
      case '7':
        return <PainEmoji7to8 />;
      case '9':
        return <PainEmoji9to10 />;
      default:
        return null;
    }
  });
  const [, answerText] = _split(answer.text, ' - ');
  return (
    <PainCard
      isMultiSelect
      isClinicalReviewMode={isClinicalReviewMode}
      triageLevel={answer.triageLevel}
      selected={selected}
      onClick={() => onSelectOption(answer)}
    >
      {emoji}
      {answerText}
    </PainCard>
  );
}
